import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-login",
  "use": "icon-login-usage",
  "viewBox": "0 0 19 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 25\" id=\"icon-login\"><path d=\"M9.438 1c2.49 0 4.5 1.988 4.5 4.452 0 2.463-2.01 4.451-4.5 4.451s-4.5-1.988-4.5-4.451C4.939 2.988 6.949 1 9.439 1Zm0 23h-8c.045-2.953 1-11.277 8-11.277s7.955 8.324 8 11.277h-8Z\" stroke=\"currentColor\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol